import React from "react";
import { Item as DropdownPrimitiveItem } from "@radix-ui/react-dropdown-menu";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
DropdownItem.propTypes = {
    children: PropTypes.node.isRequired,
    asChild: PropTypes.bool,
    onSelect: PropTypes.func,
    className: PropTypes.string
};
export default function DropdownItem(param) {
    var children = param.children, onSelect = param.onSelect, className = param.className;
    return /*#__PURE__*/ React.createElement(DropdownPrimitiveItem, {
        asChild: true,
        onSelect: onSelect,
        className: twMerge(cc([
            "flex",
            "transition-all",
            "duration-300",
            "items-center",
            "gap-x-3.5",
            "outline-none",
            "cursor-pointer",
            "p-2",
            "dark:text-gray-200",
            "dark:hover:bg-blue-750",
            "dark:focus:bg-blue-750",
            "hover:bg-blue-100",
            "focus:bg-blue-100",
            "hover:text-blue-550",
            className
        ]))
    }, /*#__PURE__*/ React.createElement("li", null, children));
}
